import { OfficeBearer } from '../masters/officebearer.model';
import { FlatOwners } from '../masters/flatOwners.model';
import { BlockRepresentativeModel } from './blockRepresentativeModel';

export class RWARegistrationEnt{

    nameOfColony:string;
    flatTotalInColony:string;
    rwaName:string;
    rwaApp_no:string;
    regNoOfRWA:string;
    socRegNumber:string;
    regDateOfSoc: Date;
    noOFFlatOfOwner: string;
    applicantIs:number;
    preFirstName:string;
    preMiddleName:string;
    preLastName:string;
    preHusbandFatherName:string;
    preMobileNo:string;
    preEmailId:string;
    preAdharNo:string;
    preUploadAdhar:string;
    createdBy:number;
    createdById:number;
    secFirstName:string;
    secMiddleName:string;
    secLastName:string;
    secHusbandFatherName:string;
    secMobileNo:string;
    secEmailId:string;
    secAdharNo:string;
    secUploadAdhar:string;
    status:number;
    houseNoRWA:string;
    streetRWA:string;
    localityRWA:string;
    districtRWA:number;
    pinCodeRWA:string;
    landLineNo:string;
    emaildIdInContact:string;
    socFileObjection:number;
    authorLetter:string;
    gbmHeldWhe:number;
    dateOfGBM:Date;
    byeLawRWA:string;
    regCert:string;
    ddaUndertaking:string;
    officebearerName:string;
    officebearerDesignation:string;
    remark:string;
    officebearer:  OfficeBearer[];
    flatOwners:  FlatOwners[];
    objectionerAgainst:string;
    blockRepresentatives:Array<BlockRepresentativeModel>;
    notificationTitle:string;
    notice:string;
    raisedObjectioner:string;
    state:string;
    flatNoFrom:number;
    flatNoTo:number;
    objectionLastDate:Date;
    reasonToRegister:string;
    fromDate:Date;
    toDate:Date;
    raisedDespute:string;
    deptUserId:number;
    byLawAdopted:string;
    copyOfRegistration:string;
    underTaking:string;
    listOfFlatOwners:string;
    otherDoc:string;
    block:string;
    remarkOfDocument:string;
    }